//File abcardinfo.js contains information about the various cards in the game.
//Most of this information is also on the blockchain, but this file loads up constant information much more quickly than reading from the chain.

//const urlRoot =
//  'https://ipfs.io/ipfs/QmXC59t9XPk2EsvqEd3RBRouSGqaPS8wFHKx3mG7Pjqej8/';

const siteRoot = 'images/'

//object containing information strings, etc about various angel battle cards. The card id is the position.
//For instance, to access information about card series 12, use ABCardInfo[12]
const ABCardInfo = {
  cards: [
    {
          location: siteRoot + '0.png',
      name: 'Barakiel',
      description: 'Common Blue Angel',
      aura: 'blue',
      type: 'light',
    },
    {
        location: siteRoot + '1.png',
      name: 'Zadkiel',
      description: 'Angel of Mercy',
      aura: 'yellow',
      type: 'light',
    },
    {
        location: siteRoot + '2.png',
      name: 'Lucifer',
      description: 'Leader of the Fallen',
      aura: 'purple',
      type: 'dark',
    },
    {
      location: siteRoot + '3.png',
      name: 'Michael',
      description: 'Prince of the Host',
      aura: 'orange',
      type: 'light',
    },
    {
      location: siteRoot + '4.png',
      name: 'Arel',
      description: 'Angel of Fire',
      aura: 'red',
      type: 'light',
    },
    {
      location: siteRoot + '5.png',
      name: 'Raguel',
      description: 'Angel of Justice',
      aura: 'yellow',
      type: 'light',
    },
    {
      location: siteRoot + '6.png',
      name: 'Lilith',
      description: 'Demon of the Night',
      aura: 'purple',
      type: 'dark',
    },
    {
      location: siteRoot + '7.png',
      name: 'Furlac',
      description: 'Angel of Earth',
      aura: 'green',
      type: 'light',
    },
    {
      location: siteRoot + '8.png',
      name: 'Azazel',
      description: 'Demon of Weapons',
      aura: 'orange',
      type: 'dark',
    },
    {
      location: siteRoot + '9.png',
      name: 'Eleleth',
      description: 'Angel of Peace',
      aura: 'blue',
      type: 'light',
    },
    {
      location: siteRoot + '10.png',
      name: 'Verin',
      description: 'Demon of Impatience',
      aura: 'red',
      type: 'dark',
    },
    {
      location: siteRoot + '11.png',
      name: 'Ziwa',
      description: 'Angel of Light',
      aura: 'yellow',
      type: 'light',
    },
    {
      location: siteRoot + '12.png',
      name: 'Cimeriel',
      description: 'The Darkness of God',
      aura: 'purple',
      type: 'dark',
    },
    {
      location: siteRoot + '13.png',
      name: 'Numinel',
      description: 'Angel of Knowledge',
      aura: 'green',
      type: 'light',
    },
    {
      location: siteRoot + '14.png',
      name: 'Bat Gol',
      description: 'Angel of the Heavenly Voice',
      aura: 'green',
      type: 'light',
    },
    {
      location: siteRoot + '15.png',
      name: 'Gabriel',
      description: 'Messenger of God',
      aura: 'blue',
      type: 'light',
    },
    {
      location: siteRoot + '16.png',
      name: 'Metatron',
      description: 'Powerful Kingly Angel',
      aura: 'red',
      type: 'light',
    },
    {
      location: siteRoot + '17.png',
      name: 'Rafael',
      description: 'God Heals',
      aura: 'yellow',
      type: 'light',
    },
    {
      location: siteRoot + '18.png',
      name: 'Melchezidek',
      description: 'Priest King',
      aura: 'purple',
      type: 'light',
    },
    {
      location: siteRoot + '19.png',
      name: 'Semyaza',
      description: 'Father of the Nephilim',
      aura: 'green',
      type: 'dark',
    },
    {
      location: siteRoot + '20.png',
      name: 'Abbadon',
      description: 'The Destroyer',
      aura: 'orange',
      type: 'dark',
    },
    {
      location: siteRoot + '21.png',
      name: 'Baalzebub',
      description: 'Lord of the Flies',
      aura: 'blue',
      type: 'dark',
    },
    {
      location: siteRoot + '22.png',
      name: 'Ben Nez',
      description: 'Angel of Wind',
      aura: 'red',
      type: 'light',
    },
    {
      location: siteRoot + '23.png',
      name: 'Jophiel',
      description: 'Cherub Guardian of Eden',
      aura: 'green',
      type: 'light',
    },
    {
      location: siteRoot + '24.png',
      name: 'Gecko',
      description: 'Level 1 Reptile',
      aura: 'Component',
      level: 1,
      type: 'reptile',
    },
    {
      location: siteRoot + '25.png',
      name: 'Parakeet',
      description: 'Level 1 Avian',
      aura: 'Component',
      level: 1,
      type: 'avian',
    },
    {
      location: siteRoot + '26.png',
      name: 'Kitten',
      description: 'Level 1 Feline',
      aura: 'Component',
      level: 1,
      type: 'feline',
    },
    {
      location: siteRoot + '27.png',
      name: 'Horse',
      description: 'Level 1 Equine',
      aura: 'Component',
      level: 1,
      type: 'equine',
    },
    {
      location: siteRoot + '28.png',
      name: 'Komodo',
      description: 'Level 2 Reptile',
      aura: 'Component',
      level: 2,
      type: 'reptile',
    },
    {
      location: siteRoot + '29.png',
      name: 'Falcon',
      description: 'Level 2 Avian',
      aura: 'Component',
      level: 2,
      type: 'avian',
    },
    {
      location: siteRoot + '30.png',
      name: 'Bobcat',
      description: 'Level 2 Feline',
      aura: 'Component',
      level: 2,
      type: 'feline',
    },
    {
      location: siteRoot + '31.png',
      name: 'Unicorn',
      description: 'Level 2 Equine',
      aura: 'Component',
      level: 2,
      type: 'equine',
    },
    {
      location: siteRoot + '32.png',
      name: 'Rock Dragon',
      description: 'Level 3 Reptile',
      aura: 'Component',
      level: 3,
      type: 'reptile',
    },
    {
      location: siteRoot + '33.png',
      name: 'Archaeopteryx',
      description: 'Level 3 Avian',
      aura: 'Component',
      level: 3,
      type: 'avian',
    },
    {
      location: siteRoot + '34.png',
      name: 'Sabertooth',
      description: 'Level 3 Feline',
      aura: 'Component',
      level: 3,
      type: 'feline',
    },
    {
      location: siteRoot + '35.png',
      name: 'Pegasus',
      description: 'Level 3 Equine',
      aura: 'Component',
      level: 3,
      type: 'equine',
    },
    {
      location: siteRoot + '36.png',
      name: 'Dire Dragon',
      description: 'Level 4 Reptile',
      aura: 'Component',
      level: 4,
      type: 'reptile',
    },
    {
      location: siteRoot + '37.png',
      name: 'Phoenix',
      description: 'Level 4 Avian',
      aura: 'Component',
      level: 4,
      type: 'avian',
    },
    {
      location: siteRoot + '38.png',
      name: 'Liger',
      description: 'Level 4 Feline',
      aura: 'Component',
      level: 4,
      type: 'feline',
    },
    {
      location: siteRoot + '39.png',
      name: 'Alicorn',
      description: 'Level 4 Equine',
      aura: 'Component',
      level: 4,
      type: 'equine',
    },
    {
      location: siteRoot + '40.png',
      name: 'Fire Elemental',
      description: 'Level 5 - Elemental',
      aura: 'Component',
      level: 5,
    },
    {
      location: siteRoot + '41.png',
      name: 'Water Elemental',
      description: 'Level 5 - Elemental',
      aura: 'Component',
      level: 5,
    },
    {
      location: siteRoot + '42.png',
      name: 'Sun Elemental',
      description: 'Level 5 - Elemental',
      aura: 'Component',
      level: 5,
    },
    {
      location: siteRoot + '43.png',
      name: 'Leather Bracers',
      description: 'Slightly Increases Battle Power',
      aura: 'None',
    },
    {
      location: siteRoot + '44.png',
      name: 'Metal Bracers',
        description: 'Greatly Increases Battle Power',
      aura: 'None',
    },
    {
      location: siteRoot + '45.png',
      name: "Scholar's Scroll",
      description: 'Increase EXP + 50',
      aura: 'None',
    },
    {
      location: siteRoot + '46.png',
      name: 'Cosmic Scroll',
      description: 'Increase EXP + 100',
      aura: 'None',
    },
    {
      location: siteRoot + '47.png',
      name: '4 Leaf Clover',
      description: 'Slightly Increases Pet Luck',
      aura: 'None',
    },
    {
      location: siteRoot + '48.png',
      name: '7 Leaf Clover',
      description: 'Greatly Increases Pet Luck',
      aura: 'None',
    },
    {
      location: siteRoot + '49.png',
      name: 'Red Collar',
      description: 'Slightly Increases Red Aura',
      aura: 'None',
       },
    {
      location: siteRoot + '50.png',
      name: 'Ruby Collar',
      description: 'Greatly Increases Red Aura',
      aura: 'None',
    },
    {
      location: siteRoot + '51.png',
      name: 'Yellow Collar',
      description: 'Slightly Increases Yellow Aura',
      aura: 'None',
    },
    {
      location: siteRoot + '52.png',
      name: 'Citrine Collar',
      description: 'Greatly Increases Yellow Aura',
      aura: 'None',
    },
    {
      location: siteRoot + '53.png',
      name: 'Blue Collar',
      description: 'Slightly Increases Blue Aura',
      aura: 'None',
    },
    {
      location: siteRoot + '54.png',
      name: 'Sapphire Collar',
      description: 'Greatly Increases Blue Aura',
      aura: 'None',
    },
    {
      location: siteRoot + '55.png',
      name: 'Carrots',
      description: 'Pet Speed Boost When Used With Equine Line',
      aura: 'None',
    },
    {
      location: siteRoot + '56.png',
      name: 'Cricket',
        description: 'Pet Speed Boost When Used With Reptile Line',
      aura: 'None',
    },
    {
      location: siteRoot + '57.png',
      name: 'Bird Seed',
        description: 'Pet Speed Boost When Used With Avian Line',
      aura: 'None',
    },
    {
      location: siteRoot + '58.png',
      name: 'Cat Nip',
        description: 'Pet Speed Boost When Used With Feline Line',
      aura: 'None',
    },
    {
      location: siteRoot + '59.png',
      name: 'Lightning Rod',
        description: 'Double Pet Speed Boost When Used With Elemental',
      aura: 'None',
    },
    {
      location: siteRoot + '60.png',
      name: 'Holy Light',
      description: 'Extra Power vs Fallen Angels',
      aura: 'None',
    },
    {
      location: siteRoot + '61.png',
      name: 'Single Ply Paper Towel',
      description: ' ',
      aura: 'None',
    },
    {
        location: siteRoot + '62.png',
      name: '2 Ply Paper Towel',
      description: ' ',
      aura: 'None',
    },
    {
        location: siteRoot + '63.png',
      name: 'Cardboard',
      description: ' ',
      aura: 'None',
    },
    {
        location: siteRoot + '64.png',
      name: 'Bronze',
      description: ' ',
      aura: 'None',
    },
    {
        location: siteRoot + '65.png',
      name: 'Silver',
      description: ' ',
      aura: 'None',
    },
    {
        location: siteRoot + '66.png',
      name: 'Gold',
      description: ' ',
      aura: 'None',
    },
    {
        location: siteRoot + '67.png',
      name: 'Platinum',
      description: ' ',
      aura: 'None',
    },
    {
        location: siteRoot + '68.png',
      name: 'Stupid Fluffy Pink',
      description: ' ',
      aura: 'None',
    },
    {
        location: siteRoot + '69.png',
      name: 'Orachalcum',
      description: ' ',
      aura: 'None',
    },
    {
        location: siteRoot + '70.png',
      name: 'Diamond',
      description: ' ',
      aura: 'None',
    },
    {
        location: siteRoot + '71.png',
      name: 'Titanium',
      description: ' ',
      aura: 'None',
    },
    {
        location: siteRoot + '72.png',
      name: 'Zeronium',
      description: ' ',
      aura: 'None',
    },
  ],
};

export default ABCardInfo;
